import React, { useEffect, useState } from 'react'
import {
  TextField,
  MenuItem,
  Box,
  Chip,
  Grid,
  TextFieldProps
} from '@mui/material'

interface GenericMultiselectProps<T> {
  initialValues: T[]
  fullWidth?: boolean
  title: string // nombre al pedir selección
  name: string // campo db para mostrar nombre en items DLL
  chipName: keyof T // campo db para mostrar nombre en chip
  valueKey: keyof T // campo db para asignar valor a cada selección
  required?: boolean
  withoutThisPositions?: number[]
  selectedItems: T[keyof T][]
  setSelectedItems: any
}
export interface GenericData {
  [key: string]: any
}

export const GenericMultiselectDLL = <T extends GenericData>({
  initialValues,
  fullWidth = false,
  title = '',
  name = 'Name',
  chipName,
  valueKey,
  required = false,
  selectedItems,
  setSelectedItems,
  ...otherProps
}: GenericMultiselectProps<T> & TextFieldProps) => {
  const [hasError, setHasError] = useState<boolean>(false)
  const [selected, setSelected] = useState<number>(-1)

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && selected === -1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [selected, required])

  const arrTypePositions =
    initialValues !== undefined
      ? initialValues
          .filter((item: T) => !selectedItems.includes(item[valueKey]))
          .map((option: T) => (
            <MenuItem key={option[valueKey]} value={option[valueKey]}>
              {option[name]}
            </MenuItem>
          ))
      : []

  const deleteItemseSelected = (elementoAEliminar: keyof T) => {
    setSelectedItems((prevState: [keyof T]) =>
      prevState.filter((el) => el !== elementoAEliminar)
    )
  }

  // Agrega state de selección para DLL y agrega selección al array
  const handleInputChange = ({ target }: any) => {
    setSelected(-1)
    if (target.value > 0) {
      setSelectedItems([...selectedItems, target.value])
    }
  }

  return (
    <Grid container spacing={1} direction='column'>
      <Grid item xs={12}>
        <TextField
          id={valueKey as string}
          name={name}
          select
          value={selected}
          onChange={handleInputChange}
          fullWidth={fullWidth}
          error={hasError}
          helperText={hasError ? `Seleccionar ${title}` : undefined}
          {...otherProps}
        >
          <MenuItem key={-1} value={-1}>
            {`Seleccionar ${title}...`}
          </MenuItem>
          {arrTypePositions}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <Box display='flex' flexWrap='wrap' mt={0.5} style={{ gap: 5 }}>
          {initialValues?.map(
            (e) =>
              selectedItems.find((wid) => wid === e[valueKey]) && (
                <Chip
                  size='small'
                  key={e[valueKey] as string}
                  label={e[chipName]}
                  onDelete={() => deleteItemseSelected(e[valueKey])}
                />
              )
          )}
        </Box>
      </Grid>
    </Grid>
  )
}
